import { useContext } from 'react';
import { WidgetSettingsProvider } from '../context';

export default function useWidgetSettings() {
    const widgetSettings = useContext(WidgetSettingsProvider.Context);

    if (!widgetSettings) {
        throw new Error('Widget settings not found.');
    }

    return widgetSettings;
}
